import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css }: any) => ({
  drawer: css`
    .ant-drawer-body {
      padding: 24px;
    }
  `,
}));

export const useModalSubscriptionCounterStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
